module.exports = __webpack_public_path__ + "0b45b6b6d8ef77936fb02f7287962ae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/banner-bg04.png
// module id = 837
// module chunks = 3